export const DELIVERY_PLATFORMS_OPTIONS = [
  { value: 'Doordash', label: 'Doordash' },
  { value: 'Grubhub', label: 'Grubhub' },
  { value: 'Uber Eats', label: 'Uber Eats' },
]
